export default {"src":"/_next/static/media/faq-icon2.291802f0.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};